export const isProduction = process.env.NODE_ENV === 'production';

const companyName = 'Mploy';
const whatsappGroupLink = 'https://chat.whatsapp.com/Izb78WJkhvWLY3xBK3gPq9';
const largeLogoSrc = '/images/logo.svg';
const smallLogoSrc = '/images/hand.svg';
const contact = {
    email: 'info@mploy.co.il',
    noReplyEmail: 'info@mploy.co.il',
};
const facebookPageLink = 'https://www.facebook.com/mploy.co.il/';

const clientConfig = {
    companyName,
    largeLogoSrc,
    smallLogoSrc,
    whatsappGroupLink,
    baseUrl: isProduction ? 'https://www.mploy.co.il/' : 'http://localhost/',
    contact,
    facebookPageLink,
};

export default clientConfig;
